import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function StopwatchIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "21"}
      height={height || "21.78"}
      viewBox="0 0 21 21.78"
    >
      <path
        id="Caminho_10178"
        data-name="Caminho 10178"
        d="M17.225,16.567l-3.711-2.2V9.377a.789.789,0,0,0-.793-.793h-.066a.789.789,0,0,0-.793.793v5.2a1.09,1.09,0,0,0,.54.947l4.019,2.411a.792.792,0,1,0,.8-1.365ZM23.071,5.292,19.68,2.473a1.1,1.1,0,1,0-1.409,1.7l3.38,2.819a1.106,1.106,0,0,0,1.42-1.7ZM4.265,6.988l3.38-2.819a1.1,1.1,0,0,0-1.4-1.7L2.856,5.292a1.1,1.1,0,0,0-.132,1.552A1.088,1.088,0,0,0,4.265,6.988Zm8.7-2.808a9.909,9.909,0,1,0,9.909,9.909A9.91,9.91,0,0,0,12.964,4.18Zm0,17.617a7.707,7.707,0,1,1,7.707-7.707A7.716,7.716,0,0,1,12.964,21.8Z"
        transform="translate(-2.464 -2.219)"
        fill={color || "#3e3e3e"}
      />
    </svg>
  );
}
